import { STATUS } from '@features/General'
import { createSlice } from '@reduxjs/toolkit'

export interface ICreateListPayload {
    name: string
}

export interface ICreateState {
    status: string
    data: any[]
    errors: any
}

const initialState: ICreateState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const createOrder = createSlice({
    name: 'hub/rfqs/createOrder',
    initialState,
    reducers: {
        onRequest(state, actions) {
            state.status = STATUS.RUNNING
        },
        onRequestClear(state) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onClear(state, action) {
            state.data = null
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const createOrderActions = createOrder.actions
export default createOrder.reducer
